import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
export const PButton = ({ mt = 0, variant = "contained", fullWidth = false, minWidth = "auto", width = undefined, maxWidth = undefined, ...props }) => {
    return (_jsx(Button, { ...props, variant: variant, fullWidth: fullWidth, sx: { mt, width, maxWidth, minWidth, fontWeight: 500, fontSize: { xs: '14px !important', sm: "14px !important" } }, children: props.children }));
};
